import React from "react";

const STEPS = [
  { n: "01", t: "Cue", d: "A time or trigger you can't miss — Sunday morning, payday, first of the month." },
  { n: "02", t: "Routine", d: "Open your calendar. Place bills on days. Log expenses. Mark things paid." },
  { n: "03", t: "Reward", d: "A margin at month-end, a streak on the wall, a quieter mind about money." },
];

export default function LoopMethod() {
  return (
    <section id="loop" className="max-w-7xl mx-auto px-6 md:px-10 py-20 border-t border-[#E6E3DB]">
      <p className="eyebrow text-[#607762]">The Method</p>
      <h2 className="font-serif text-4xl md:text-5xl mt-3 max-w-3xl">
        Three beats. Every week. Forever.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mt-12">
        {STEPS.map((s) => (
          <div key={s.n} className="border-l border-[#C05C3D] pl-6 py-2" data-testid={`loop-step-${s.n}`}>
            <p className="font-serif text-6xl text-[#C05C3D] leading-none">{s.n}</p>
            <h3 className="font-serif text-3xl mt-4">{s.t}</h3>
            <p className="text-[#4d4f4c] mt-3 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
